module.exports = __webpack_public_path__ + "static/media/25th Avenue, San Francisco, CA4.feda2872.jpg";